export class LocationWaysFactor
{
    id:number;
    regionId:number;
    values:LocationWaysFactorValue[];
}
export class LocationWaysFactorValue
{
    placeId:number;
    value:number;
}